export default function ({ $axios, redirect, route, isDev }, inject) {
  if (process.server || isDev) {
    $axios.setBaseURL('http://localhost:8040')
  }

  // $axios.onError(err => {
  //   if (err.response.status === 401) {
  //     window.location.href = `/login?redirect=${encodeURIComponent(route.path)}`
  //   }
  // })
}
